import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { styles } from './action-window-styles';

const ActionWindowItemDetails: React.FC<Props> = (props: Props): JSX.Element => {
  const {
    baseUnit,
    isLinkedItemTare,
    unitOfMeasure,
    atomicMsuPrice,
    atomicMsuUnitForPrice,
    atomicMsuUnit,
    isManualTareItem,
    isWeighted,
    isPackItem,
  } = props;
  const classes = styles({});
  const { t } = useTranslation();
  const { usePackIdentifier } = getCurrentXLRConfig();

  return (
    <Grid item className={classes.alignCenter}>
      <span className={classes.lineItem} data-testid='action-window-base-unit-text'>
        ({baseUnit} {isWeighted && unitOfMeasure}
      </span>
      <span className={classes.lineItem} data-testid='action-window-quantifier-text'>
        {` ${isLinkedItemTare || isManualTareItem ? t('TareNet') : ' '} `}
      </span>
      <span className={classes.lineItem} data-testid='action-window-item-price-per-unit'>
        x {atomicMsuPrice ? atomicMsuPrice : convertCurrency(0)}
      </span>
      <span className={classes.UOMText} data-testid='action-window-unit-text'>
        {' /'} {atomicMsuUnitForPrice}{' '}
        {isPackItem && usePackIdentifier ? `${t('UOM_Pack')}` : atomicMsuUnit}
      </span>
      <span className={classes.lineItem}>)</span>
    </Grid>
  );
};

interface Props {
  baseUnit: number | string;
  unitOfMeasure: string;
  isLinkedItemTare: number | undefined;
  atomicMsuPrice: string;
  atomicMsuUnitForPrice: string;
  atomicMsuUnit: string;
  isManualTareItem?: boolean;
  isWeighted: boolean;
  isPackItem: boolean | undefined;
}

export default ActionWindowItemDetails;
